import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const CreditLinesPage = lazy(() => import('@/containers/Views/CreditLines/CreditLinesPage'));
const CreditLineDetails = lazy(() => import('@/containers/Views/CreditLines/CreditLineDetails'));

const CreditLinesRouter = (
  <Route path="credit_lines">
    <Route
      index
      element={(
        <PrivateRoute
          pageName={EPage.CreditLines}
          permissions={EBasicActions.Find}
        >
          <CreditLinesPage />
        </PrivateRoute>
      )}
    />
    <Route
      path=":id"
      element={(
        <PrivateRoute
          pageName={EPage.CreditLines}
          permissions={EBasicActions.Find}
        >
          <CreditLineDetails />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default CreditLinesRouter;
